import * as React from 'react';
import { ChangeEvent } from 'react';
import EstimationChangeRequested from '../../application/estimations/events/EstimationChangeRequested';
import { connect } from 'react-redux';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';
import ApplicationState from '../../application/core/State';
import EstimationPeriod from '../../domain/EstimationPeriod';
import { Month } from '../admin/getEstimationMonths';
import { default as EstimationsModel, getEstimationForMonthArticleAndSku } from '../../domain/estimations/Estimations';
import Product, { Item } from '../../domain/Product';
import getEstimationStatus from '../../domain/estimations/getEstimationStatus';
import EstimationStatus from '../../domain/estimations/EstimationStatus';
import preventExpotential, { removeExpotential } from '../preventExpotential';

interface Props {
    product: Product;
    userDiscount: number;
}

interface StateProps {
    estimationPeriod: EstimationPeriod;
    estimations: EstimationsModel;
    savedDraftEstimations: EstimationsModel;
    placedEstimations: EstimationsModel;
}

class Estimation extends React.PureComponent<Props & DispatchProps & StateProps> {
    public render(): JSX.Element {
        return (
            <div className="order-details estimation-details">
                {this.props.product.items.map((item: Item) => (
                    <div key={item.number} className="order-details-row">
                        <div className="order-details-size">
                            <span>{item.size}</span>
                        </div>
                        {this.props.estimationPeriod.months.map((month: Month, index: number) => (
                            <div key={index}>
                                <input
                                    className={this.getClass(item.number, month)}
                                    type="number"
                                    min="0"
                                    max={Number.MAX_SAFE_INTEGER}
                                    step={this.props.product.packageSize}
                                    value={this.removeLeadingZeros(this.getEstimationForSizeAndMonth(item.number, month))}
                                    // tslint:disable:jsx-no-lambda
                                    onChange={(event: ChangeEvent<HTMLInputElement>): void =>
                                        this.estimationUpdated(event.target.value, item.number, item.variantCode, month)
                                    }
                                    onBlur={(event: ChangeEvent<HTMLInputElement>): void =>
                                        this.estimationUpdated(event.target.value, item.number, item.variantCode, month, true)
                                    }
                                    onKeyPress={(event: React.KeyboardEvent<HTMLInputElement>): void => preventExpotential(event)}
                                    onPaste={(event: React.ClipboardEvent<HTMLInputElement>): void => {
                                        removeExpotential(event, event.clipboardData.getData('Text'));
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    }

    private estimationUpdated = (value: string, sku: string, variantCode: string, month: Month, shouldValidate: boolean = false): void => {
        this.props.dispatch(new EstimationChangeRequested(this.props.product, sku, variantCode, month, Number(value), shouldValidate));
    };

    private removeLeadingZeros = (value: number): string => {
        return value === 0 ? '' : value.toString();
    };

    private getEstimationForSizeAndMonth = (sku: string, month: Month): number =>
        getEstimationForMonthArticleAndSku(this.props.estimations, this.props.product.articleId, sku, month);

    private getSavedEstimationForSizeAndMonth = (sku: string, month: Month): number =>
        getEstimationForMonthArticleAndSku(this.props.savedDraftEstimations, this.props.product.articleId, sku, month);

    private getPlacedEstimationForSizeAndMonth = (sku: string, month: Month): number =>
        getEstimationForMonthArticleAndSku(this.props.placedEstimations, this.props.product.articleId, sku, month);

    private getClass = (sku: string, month: Month): string => {
        const currentValue = this.getEstimationForSizeAndMonth(sku, month);
        const savedValue = this.getSavedEstimationForSizeAndMonth(sku, month);
        const placedValue = this.getPlacedEstimationForSizeAndMonth(sku, month);
        const status = getEstimationStatus(currentValue, savedValue, placedValue);
        let result = 'order-details-month-input';
        switch (status) {
            case EstimationStatus.New: {
                return (result += ' not-saved');
            }
            case EstimationStatus.Draft: {
                return (result += ' draft');
            }
            case EstimationStatus.Placed: {
                return (result += ' placed');
            }
        }
        return result;
    };
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    estimationPeriod: state.admin.estimationPeriod!,
    estimations: state.estimations.estimations,
    savedDraftEstimations: state.estimations.savedDraftEstimations,
    placedEstimations: state.estimations.placedEstimations
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Estimation);



// WEBPACK FOOTER //
// ./src/view/estimations/Estimation.tsx